
import { defineComponent, onMounted, ref } from "vue";
import { gsap } from "gsap";

import Logo from "@/components/Shared/Logo/Logo.vue";

export default defineComponent({
  name: "Preloader",
  components: {
    Logo,
  },
  setup() {
    const percent = ref(1);
    const loading = () => {
      const tl = gsap.timeline({
        paused: true,
      });
      tl.to("#barconfirm", {
        duration: 0.8,
        width: "100%",
      })
        .to("#preloader, #logo", {
          opacity: "0",
          duration: 0.8,
          ease: "power2.inOut",
          delay: 0.5,
        })
        .to("#preloader-wrapper", {
          backgroundColor: "transparent",
        })
        .to(
          "#top",
          {
            y: "-100%",
            ease: "power4.out",
            duration: 1.5,
          },
          "vertical"
        )
        .to(
          "#bottom",
          {
            y: "100%",
            ease: "power4.out",
            duration: 1.5,
          },
          "vertical"
        )
        .set("#preloader-wrapper", {
          display: "none",
        })
        .set("body", {
          overflowY: "auto",
        });

      const barconfirm = document.querySelector("#barconfirm") as HTMLElement;
      let id: number;
      const move = () => {
        id = setInterval(frame, 50);
      };
      const frame = () => {
        if (percent.value >= 100) {
          clearInterval(id);
          tl.play();
        } else {
          percent.value++;
          barconfirm.style.width = percent.value + "%";
        }
      };
      move();
    };

    onMounted(loading);

    return {
      percent,
    };
  },
});
